import { useEffect, useState } from "react";
import MultiDropdown, {
	MultiDropdownProps,
} from "../MultiDropdown/MultiDropdown";
import { set } from "date-fns";
import { DropdownOptions } from "../FormFields/DropdownField";

const AutoFillDropdown = (props: AutoFillDropdownProps) => {
	const [searchValue, setSearchValue] = useState<string>("");
	const [options, setOptions] = useState<DropdownOptions[]>([]);

	const setAutofillOptions = async () => {
		const autoFillOptions = await props.autoFill(searchValue);

		if (autoFillOptions && autoFillOptions.length > 0) {
			setOptions(autoFillOptions);
		} else {
			setOptions([]);
		}
	};
	useEffect(() => {
		if (!searchValue) {
			setOptions([]);
			return;
		}

		setAutofillOptions();
	}, [searchValue]);

	return (
		<MultiDropdown
			{...props}
			hideCheckbox
			singleSelect
			onSearch={setSearchValue}
			options={options}
		/>
	);
};

export default AutoFillDropdown;

interface AutoFillDropdownProps
	extends Omit<MultiDropdownProps, "options" | "onSearch"> {
	autoFill(searchValue: string): Promise<DropdownOptions[]>;
}
